import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/risk/')({
    beforeLoad: ({ params }): never => {
        throw redirect({
            to: '/console/$orgId/configuration/risk/appetite',
            params,
            replace: true,
        });
    },
});
